import SavingsIcon from '@mui/icons-material/Savings';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import CategoryIcon from '@mui/icons-material/Category';
import { ServiceMetaData } from './common';

export const serviceTypes: { [key: string]: ServiceMetaData } = {
  SEARCHABLE_BILL: {
    dataForm: 'BillPay',
    displayName: 'Bill Pay',
    active: true,
    icon: <SavingsIcon />,
  },
  TOPUP: {
    dataForm: 'TopUp',
    displayName: 'Top Up',
    active: false,
    icon: <SavingsIcon />,
  },
  CASHIN: {
    dataForm: 'CashIn',
    displayName: 'Cash In',
    active: false,
    icon: <SavingsIcon />,
  },
  CASHOUT: {
    dataForm: 'CashOut',
    displayName: 'Cash Out',
    active: false,
    icon: <SavingsIcon />,
  },
  PRODUCT: {
    dataForm: 'BillPay',
    displayName: 'Product',
    active: true,
    icon: <CategoryIcon />,
  },
  VOUCHER: {
    dataForm: 'Voucher',
    displayName: 'Voucher',
    active: false,
    icon: <SavingsIcon />,
  },
  SUBSCRIPTION: {
    dataForm: 'BillPay',
    displayName: 'Subscriptions',
    active: true,
    icon: <SubscriptionsIcon />,
  },
};
